import { action } from 'satcheljs';

export const onMailSearchComplete = action('ON_MAIL_SEARCH_COMPLETE');
